module.exports = __webpack_public_path__ + "static/media/44_B.43fbd774.png";